module.exports = __webpack_public_path__ + "img/nitja-pilotgalleriet-500px.5e7e5b54.svg";